import { useState } from "react";
import { Users, X, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { RoleBadge } from "@/components/Badges";
import { useAuth } from "@/context/AuthContext";

export function TeamPratica({ pratica, users, onUpdated }) {
  const { user } = useAuth();
  const [sel, setSel] = useState("");
  const canEdit = ["admin", "project_manager"].includes(user?.role);
  const members = (pratica.team || []).map((id) => users.find((u) => u.id === id)).filter(Boolean);
  const available = users.filter((u) => !(pratica.team || []).includes(u.id));

  const save = async (team) => {
    try { const { data } = await api.put(`/pratiche/${pratica.id}/team`, { team }); onUpdated({ ...pratica, team: data.team }); toast.success("Team aggiornato"); } catch (err) { toast.error(formatApiError(err)); }
  };

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5" data-testid="team-pratica">
      <div className="flex items-center gap-2 mb-3"><Users size={16} className="text-[#003087]" /><h3 className="font-heading font-medium text-slate-900">Team della pratica</h3><span className="ml-auto text-xs text-slate-500">{members.length}</span></div>
      <div className="space-y-2">
        {members.length === 0 && <p className="text-xs text-slate-500">Nessun professionista assegnato.</p>}
        {members.map((m) => (
          <div key={m.id} className="flex items-center gap-2.5" data-testid={`team-pratica-member-${m.id}`}>
            <div className="h-8 w-8 rounded-full bg-slate-800 text-white flex items-center justify-center text-xs font-semibold overflow-hidden shrink-0">{m.picture ? <img src={m.picture} alt="" className="h-full w-full object-cover" /> : m.name.slice(0, 1).toUpperCase()}</div>
            <div className="min-w-0 flex-1"><div className="text-sm text-slate-900 truncate">{m.name}</div><RoleBadge role={m.role} /></div>
            {canEdit && <button onClick={() => save(pratica.team.filter((id) => id !== m.id))} className="text-slate-300 hover:text-red-600 transition-colors" data-testid={`team-pratica-remove-${m.id}`} title="Rimuovi"><X size={14} /></button>}
          </div>
        ))}
      </div>
      {canEdit && available.length > 0 && (
        <div className="flex gap-2 mt-4">
          <select value={sel} onChange={(e) => setSel(e.target.value)} className="flex-1 h-9 rounded-md border border-slate-200 bg-slate-50 px-2 text-xs" data-testid="team-pratica-select">
            <option value="">Aggiungi professionista…</option>
            {available.map((u) => <option key={u.id} value={u.id}>{`${u.name} — ${u.role}`}</option>)}
          </select>
          <button disabled={!sel} onClick={() => { save([...(pratica.team || []), sel]); setSel(""); }} className="h-9 px-3 rounded-md bg-[#003087] text-white text-xs font-medium disabled:opacity-40 inline-flex items-center gap-1" data-testid="team-pratica-add-button"><Plus size={13} /> Aggiungi</button>
        </div>
      )}
    </div>
  );
}
